import React from "react";

function About() {
    return (
        <div className={"App-about"}>
            <h1 className={"title"}>Om dJubileet</h1>
            <p>
                dJubileet händer bara var femte år, och är troligen det största eventet som händer under din tid på sektionen.</p>
            <p>För att fira alla våra underbara projekt, nämnder och medlemmar är det i höst dags att fira att Konglig Datasektionen har
                funnits i hela 40 år, och det kommer bli större och bättre än någonsin!</p>
            <p> Vi mjukstartar med ett hemligt spektakel under våren för er som bara inte kan vänta till hösten. Födelsedagsveckorna i september och oktober kommer sedan
                vara fullspäckade med roliga event. Veckorna kommer bland annat bjuda på en finare tillställning i form av en banquette
                värdig kungen själv, och avslutas med den ballaste och mest urflippade slutfesten ni kan tänka er. </p>
            </div>
      );
}

export default About;
/*
Året var 1983 och på KTH hade en ny utbildning skapats. 
De första datalogerna sökte likasinnade och gemenskap, och 
så kom Konglig Datasektionen till den 7:e oktober samma år. 
Sedan dess har sektionen firats var femte år med buller och bång. 
Men vad är då dJubileet? dJubileet är det projekt som anordnar 
festligheterna och ser till att Konglig Datasektion får det 
hyllandet som sektionen förtjänar.*/